<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import Guid from 'guid'

  export default {
    props: {
      Parent: {
        type: Object,
        default: {}
      },
      PostDetails: {
        type: Object
      },
      SubscriptionModuleId: {
        type: [String, Number],
        default: 0
      },
      IsFrom: {
        type: String,
        default: 'Content'
      }
    },
    computed: {
      ...mapGetters([
        'ContentPage',
        'MainMenuLayout',
        'AppConfig',
        'resource',
        'DesignSettings'
      ]),
    
      ImageStyle() {
        return {
          'min-height': '50vw',
          'background-image': `url(${this.AppConfig.Urls.ContentAssetsBaseUrl + this.PostDetails.PostImage})`
        }
      },
      commentTimeStampStyle() {
        if (this.DesignSettings.BackgroundThemeMode === 1) {
          return {
            'color': '#b9b9b9' // in case of light background theme: #b9b9b9
          }
        } else {
          return {
            'color': '#747474' // in case of dark background theme: #747474
          }
        }
      },
      ContentElements() {
        let contentData = this.PostDetails.Content
        let contentElements
        if (!Helper.IsNullOrEmpty(contentData)) {
          contentElements = JSON.parse(contentData)
        }
        return contentElements
      },
      SetViewType() {
        if (this.ContentPage.ContentPages.length === 1 &&
        this.ContentPage.ContentPages[0].Posts.length === 1) {
          return 1
        }
        return 2
      },
      PostByShow() {
        return this.IsFrom !== 'Content'
      },
      EventTitleShow() {
        return this.IsFrom === 'Event'
      },
      POITitleShow() {
        return this.IsFrom === 'POI'
      },
      AllowLikes() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowLikes)
      },
      AllowAddingToFavorites() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowAddingToFavorites)
      },
      AllowSharing() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowSharing)
      },
      AllowComments() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowComments)
      },
      subtitle() {
        if (this.AllowLikes && this.AllowComments) {
          return '<div class="headerOption__item"><span>' + (this.PostDetails.PostLikes ? this.PostDetails.PostLikes : 0) + '<span class="icon-dislike-them-color"></span></span> <span>' + (this.PostDetails.PostComments ? this.PostDetails.PostComments.length : 0) + '<span class="icon-comment"></span></span></div>'
        } else if (this.AllowLikes) {
          return '<div class="headerOption__item"><span>' + (this.PostDetails.PostLikes ? this.PostDetails.PostLikes : 0) + '<span class="icon-dislike-them-color"></span></span></div>'
        } else if (this.AllowComments) {
          return '<div class="headerOption__item"><span>' + (this.PostDetails.PostComments ? this.PostDetails.PostComments.length : 0) + '<span class="icon-comment"></span></span></div>'
        }
      },
      POItitle() {
        // if (!Helper.IsNullOrEmpty(this.PostDetails.MapAddressLine1) && !Helper.IsNullOrEmpty(this.PostDetails.MapAddressLine2)) {
        //   return `${this.PostDetails.MapAddressLine1} | ${this.PostDetails.MapAddressLine2}`
        // } else
        if (!Helper.IsNullOrEmpty(this.PostDetails.MapAddressLine1)) {
          return `${this.PostDetails.MapAddressLine1}`
        }
        // else if (!Helper.IsNullOrEmpty(this.PostDetails.MapAddressLine2)) {
        //   return `${this.PostDetails.MapAddressLine2}`
        // }
      },
      Newstitle() {
        if (!Helper.IsNullOrEmpty(this.PostDetails.PostDate) && !Helper.IsNullOrEmpty(this.PostDetails.PostAuthor)) {
          return `${this.formattedDate(this.PostDetails.PostDate)} | ${this.PostDetails.PostAuthor}`
        } else if (!Helper.IsNullOrEmpty(this.PostDetails.PostDate)) {
          return `${this.formattedDate(this.PostDetails.PostDate)}`
        } else if (!Helper.IsNullOrEmpty(this.PostDetails.PostAuthor)) {
          return `${this.PostDetails.PostAuthor}`
        }
      },
      Navigationurl() {
        let pageUrl
        if (this.IsFrom === 'News') {
          pageUrl = '/news-detail-view/'
        } else if (this.IsFrom === 'Event') {
          pageUrl = '/event-detail-view/'
        } else if (this.IsFrom === 'POI') {
          pageUrl = '/poi-detail-view/'
        } else {
          pageUrl = '/text-content-detail-view/'
        }
        return `${pageUrl}${this.SubscriptionModuleId}/${this.PostDetails.Id}`
      }
    },
    methods: {
      ...mapActions([
        'showLoader',
        'hideLoader',
        'loadContentPagesLocalData',
        'loadContentPages',
        'setUserCommentData',
        'addUpdateLike',
        'addMyFavorite'
      ]),
      IsValid: function(value) {
        return Helper.IsValid(value)
      },
      formattedDate: function(value) {
        return Helper.FormattedDateDDMMMMYY(value)
      },
      timeAgo: function(value) {
        return Helper.timeAgoFromNow(value)
      },
      day: function(value) {
        return Helper.EventFormatDate(value, 'DD')
      },
      month: function(value) {
        return Helper.EventFormatDate(value, 'MMM')
      },
      EventDateTime: function(obj) {
        return Helper.EventDateTime(obj, this.resource.strUhr)
      },
      FillCommentDetails() {
        let guid = Guid.create()
        let myDate = Helper.CurrentDateTime()
        this.setUserCommentData({
          Id: guid.value,
          CommentAuthor: '',
          CommentEmail: '',
          Comment: '',
          ModulesContentPagesPosts_Id: this.PostDetails.Id,
          Reference_Id: this.PostDetails.Id,
          RowCreated: myDate,
          RowUpdated: myDate,
          RowDeleted: false,
          AppGUID: this.AppConfig.AppGUID,
          NotificationContent: {
            Id: guid.value,
            Title: this.PostDetails.Title,
            ImageName: this.PostDetails.PostImage,
            Comment: '',
            Navigationurl: this.Navigationurl
          }
        })
      },
      ConvertBoolean(value) {
        return Helper.convertBoolean(value)
      }
    },
    data() {
      return {
        IsLiked: false,
        IsFavorite: false
      }
    }
  }
</script>
<template>
  <f7-page-content v-if="PostDetails">
    <div class="detailTitleWrapper" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage)">
      <f7-col width="100" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage) && IsValid(PostDetails.PostImage)" class="cover-background" :style="ImageStyle">
      </f7-col>
      <f7-block-title v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage) && !EventTitleShow" class="block-title-contentDetails">
        {{PostDetails.Title}}
      </f7-block-title>
      <f7-block-title class="block-title-contentDetails" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage) && EventTitleShow">
        <div>
          <div class="card__headerCalendar">
            <div Class="card__headerCalendarDate">
              {{day(PostDetails.EventStartDate)}}
              <div Class="card__headerCalendarMonth">
                {{month(PostDetails.EventStartDate)}}
              </div>
            </div>
          </div>
          <div class="card__headerDesc"> {{PostDetails.Title}}
          </div>
        </div>
      </f7-block-title>
      <div class="block__headerOption" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage)" v-html="subtitle">
        <!-- <span>{{PostDetails.PostLikes}}<span class="icon-dislike-them-color"></span></span>
        <span>{{PostDetails.PostComments.length}}<span class="icon-comment"></span></span> -->
      </div>
    </div>
    <div class="block__postedBy block__postedByColor" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage) && PostByShow && !EventTitleShow && !POITitleShow">
      {{Newstitle}}
    </div>
    <div class="block__postedBy block__postedByColor" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage) && PostByShow && POITitleShow">
      {{POItitle}}&nbsp;
    </div>
    <div class="block__postedBy block__postedByColor" v-if="ConvertBoolean(Parent.ShowPostHeaderOnDetailPage) && PostByShow && EventTitleShow">
        <span>{{EventDateTime(PostDetails)}}</span><br/>
        <span>{{PostDetails.EventLocation}}</span>
      </div>
    <div v-if="ContentElements" class="content-section">
      <component v-for="(el,index) in ContentElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
      </component>
    </div>
    <template v-if="AllowComments">
      <div style='padding:22px;margin:0;'>
        <f7-button big fill :outline="true" :raised="true" no-fast-click @click="FillCommentDetails()" popup-open="#comment-popup">{{resource.addCommentBtn}}</f7-button>
      </div>
      <f7-button big fill class="button__removeRadius">{{PostDetails.PostComments.length}} {{resource.comment}}</f7-button>
      <f7-block></f7-block>
      <div v-for="(Comment, index) in PostDetails.PostComments" :key="index" style='padding:0;margin:0;'>
      <f7-card class="cardInfo">
        <f7-card-header>
          <div class="cardInfo__header">
            {{Comment.CommentAuthor}}
          </div>
          <div class="cardInfo__postedBy" :style="commentTimeStampStyle">{{timeAgo(Comment.CommentDate)}}</div>
        </f7-card-header>
        <f7-card-content>
          {{Comment.Comment}}
        </f7-card-content>
      </f7-card>
    </div>
    </template>
  </f7-page-content>
</template>
<style scoped>
  .button__removeRadius {
    border-radius: 0;
  }
  .cardInfo .cardInfo__header {
    font-size: 0.8em;
  }
  .cardInfo .cardInfo__postedBy {
    font-size: 0.7em;
  }
  .block__postedBy {
    color: #3b3b3d;
    font-size: 0.8em;
    padding: 36px 10px 10px 15px;
  }
  .block__headerOption .icon-dislike-them-color,
  .block__headerOption .icon-comment {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .block__headerOption {
    float: right;
    margin: 0.5em 1.5em 0 0;
    font-size: 0.8em;
  }
  .block__headerOption .icon {
    font-size: 0.9em;
  }
  .block-title-contentDetails {
    margin-top: 10px;
    overflow: initial;
    white-space: initial;
    text-overflow: initial;
    line-height: 24px;
    margin-bottom: 0;
    font-size: 20px;
  }
  .margin-to-25 {
    margin-top: 25px;
  }
  .card__headerCalendar {
    float: left;
    padding: 3px 12px 10px 0px;
  }
  .card__headerCalendarDate {
    width: 35px;
    height: 40px;
    background-color: #fff;
    color: #333;
    position: relative;
    text-align: center;
    font-weight: 700;
    font-size: 1.2em;
  }
  .card__headerCalendarMonth {
    position: absolute;
    width: 100%;
    background-color: #007aff;
    color: #fff;
    bottom: 0;
    font-size: .5em;
    /* padding: 1px 0; */
    line-height: 16px;
  }
  .detailTitleWrapper {
    float: left;
    width: 100%;
    padding-bottom: 10px;
    margin-bottom: 15px;
  }
  .card__headerDesc {
    margin-left: 46px;
    text-transform: uppercase;
  }
  .toolbar-fixed .page-content {
      padding-bottom: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/CommonDetail.vue